import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import details from '../../../img/details.svg';
import add from '../../../img/add.svg';


export default class EventTypesScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              event_types: []  
        }
    }  
    
    async componentDidMount() {
        BaseApi.get('/event/types', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.setState({event_types: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openEventType(id) {
        this.props.navigate("event-type", {caller: "event-types", callargs: this.state.args, event_type: id})
    }

    renderEventType(event_type) {
        return (
            <tr 
                key={event_type.id}
                className="table-row-clickable"
                onClick = {()=>this.openEventType(event_type.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>{event_type.name}</td>
                <td style={{textAlign: 'left',  padding: '4px'}}>{event_type.description}</td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Типы событий"}/>
                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">    
                    </div>
                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button className="btn btn-primary d-flex align-items-center" onClick={()=>{this.openEventType("")}}>
                                Добавить тип
                            </button>
                        </div>
                    </div>
                </div>



                <div class="card shadow-sm">
                    <div class="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th>Наименование</th>
                                        <th>Описание</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.event_types.map((value, index) => this.renderEventType(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event-types.js